export const BASE_INVOICE_PATH = '/invoices';

export const INDEX_INVOICE_PATH = `${ BASE_INVOICE_PATH }/all`;
export const NEW_INVOICE_PATH = `${ BASE_INVOICE_PATH }/new`;
export const EDIT_INVOICE_PATH = `${ BASE_INVOICE_PATH }/edit/:id`;
